export function getStoredAuth() {
  try {
    const raw = localStorage.getItem('maestro_auth');
    if (raw) return JSON.parse(raw);
  } catch {
    /* ignore */
  }
  return null;
}

export function applySuccessfulSave(genres) {
  localStorage.setItem('maestro_onboarding_complete', 'true');
  try {
    localStorage.setItem('maestro_onboarding_genres', JSON.stringify(genres));
  } catch {
    /* ignore */
  }
}
